import styled from "styled-components";

export const StyledBoxContent =styled.div`
display: flex;
justify-content: space-between;
color: var(--color-white);
cursor: pointer;

span{
   background-color: var(--color-salmon);
    padding: 5px;
    border-radius: 3px;
}

`